var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imports-page"},[_c('app-page-header',{attrs:{"title":"Importações"}}),_c('imports-table',{ref:"importsTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }